// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkopd34{border-radius:var(--ds-border-radius-200,8px)}._16qszucj{box-shadow:var(--ds-shadow-raised,0 1px 1px #091e4240,0 0 1px #091e424f)}\n._18m915vq{overflow-y:hidden}\n._1reo15vq{overflow-x:hidden}\n._1dbz7hy2:hover{box-shadow:0 5px 9pt 0 var(--ds-border,#091e4224)}\n._d0altlke:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
